// extracted by mini-css-extract-plugin
export default {"homeInner":"home_homeInner__nzAC6"};